const VID_KEY = "bt_device_vid";
const SESS_KEY = "bt_device_sess";
const ADMIN_MARKER = "bt_internal_admin";
const THIRTY_MIN = 30 * 60 * 1000;

const randomId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};

const classifyDevice = () => {
  const ua = navigator.userAgent || "";
  if (/Mobi|Android|iPhone|iPod|iPad|Tablet|Silk|Kindle|PlayBook|Opera Mini/i.test(ua)) return "mobile";
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return "mobile";
  return "desktop";
};

export function markInternalAdmin() {
  try {
    localStorage.setItem(ADMIN_MARKER, "1");
  } catch {}
}

export function trackDeviceVisit(apiBase) {
  try {
    if (navigator.webdriver) return;
    if (localStorage.getItem(ADMIN_MARKER) || sessionStorage.getItem("bt_admin_pw")) return;
    let vid = localStorage.getItem(VID_KEY);
    if (!vid || !/^[a-f0-9]{32}$/.test(vid)) {
      vid = randomId();
      localStorage.setItem(VID_KEY, vid);
    }
    const now = Date.now();
    let sess = null;
    try {
      sess = JSON.parse(localStorage.getItem(SESS_KEY));
    } catch {}
    if (!sess || !sess.sid || now - (sess.at || 0) > THIRTY_MIN) {
      sess = { sid: randomId(), at: now, sent: false };
    }
    sess.at = now;
    const send = !sess.sent;
    sess.sent = true;
    localStorage.setItem(SESS_KEY, JSON.stringify(sess));
    if (!send) return;
    fetch(`${apiBase}/track/device`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visitor_id: vid, session_id: sess.sid, device: classifyDevice() }),
      keepalive: true,
    }).catch(() => {});
  } catch {}
}
